import { ouvrir } from './base.js';

/**
 * Réglages d'appareil - document 02, section 4. Singleton, jamais synchronisé.
 */
const CLE = 'singleton';

export const REGLAGES_DEFAUT = {
  syncUrl: '',
  deviceToken: '',
  deviceName: '',
  lastSyncAt: null,
  theme: 'corridor',

  // Seuils d'alerte de pilotage - document 07, section 7.
  //
  // Propres à l'appareil comme le reste des réglages, et donc non
  // synchronisés : ils disent ce que VOUS voulez surveiller, pas un fait du
  // livre. Zéro pour les caisses, ce qui signale tout découvert. L'exposition
  // n'a pas de défaut raisonnable - le volume porté dépend de l'activité de
  // chacun - donc `null`, qui vaut « pas d'alerte » tant qu'il n'est pas posé.
  seuilCaisseEur: 0,
  seuilCaisseXaf: 0,
  seuilCaisseXof: 0,
  seuilExpoEur: null,
};

export async function lireReglages() {
  const db = await ouvrir();
  return { ...REGLAGES_DEFAUT, ...(await db.get('settings', CLE)) };
}

export async function ecrireReglages(partiel) {
  const db = await ouvrir();
  const fusion = { ...(await lireReglages()), ...partiel };
  await db.put('settings', fusion, CLE);
  return fusion;
}
